/* Copyright (c) 2020-present CloudIO Inc */

import { StateXGetter } from '@cloudio-saas/statex';
import {
  formulaItemPropsAtom,
  itemPropPath,
  itemTypeAtom,
  runtimeItemPropAtom,
} from 'designer/atoms';
import { getDefaultValues } from 'layout/Sidebar/panels/PropertiesView/property-editors/PropertyEditorUtils';
import { ItemID, getManager } from 'componentregistry';

export function getRuntimeProp<T, K extends keyof T = keyof T>(
  getter: StateXGetter,
  appUid: string,
  pageId: ItemID,
  itemId: ItemID,
  prop: K,
): T[K] {
  return getter(runtimeItemPropAtom, {
    // @ts-ignore prop is string
    params: { appUid, pageId, itemId, prop },
  }) as T[K];
}

export function getFormulaItemProp<T, K extends keyof T = keyof T>(
  getter: StateXGetter,
  appUid: string,
  pageId: ItemID,
  itemId: ItemID,
  prop: K,
): T[K] {
  return getter(formulaItemPropsAtom, {
    // @ts-ignore prop is string
    params: { appUid, pageId, itemId, prop },
  }) as T[K];
}

export function getItemProp<T, K extends keyof T = keyof T>(
  getter: StateXGetter,
  appUid: string,
  pageId: ItemID,
  itemId: ItemID,
  key: K,
): T[K] {
  let val = getRuntimeProp<T, K>(getter, appUid, pageId, itemId, key);
  if (val !== undefined && val !== null) {
    return val;
  }
  val = getFormulaItemProp(getter, appUid, pageId, itemId, key);
  if (val !== undefined && val !== null) {
    return val;
  }
  return getDesignProp<T, K>(getter, appUid, pageId, itemId, key);
}

export function getDesignProp<T, K extends keyof T = keyof T>(
  getter: StateXGetter,
  appUid: string,
  pageId: ItemID,
  itemId: ItemID,
  prop: K,
): T[K] {
  let value = getter(itemPropPath, {
    // @ts-ignore prop is string
    params: { appUid, pageId, itemId, prop },
  }) as T[K];
  if (value === undefined || value === null) {
    // get default value
    const type = getter(itemTypeAtom, {
      params: { appUid, pageId, itemId },
    });
    const mgr = getManager(type);
    value = getDefaultValues(mgr, prop as string);
  }
  return value;
}
